module.exports = __webpack_public_path__ + "img/teamImg30.69943c82.jpg";